export default {
  mapForm: {
    'placesAndDirections': 'Cerca e vai',
    'isochrones': 'Raggiungibilità',
    'uploadedContentRendered': 'Contenuto importato pronto',
    'errorRenderingContentUploaded': 'Errore durante la visualizzazione del contenuto importato. Controlla formato e contenuto del file'
  }
}
